import { ChartDataContainer } from "@arelia-types/index";
import { sumBy } from "lodash";

export function combineChartData(chartData: ChartDataContainer[]): {
  labels: string[],
  data: number[][]
} {
  return {
    labels: chartData[0]?.labels ?? [],
    data: chartData.map(x => x.data)
  };
}

export function combineChartDataAndSum(chartData: ChartDataContainer[]): ChartDataContainer {
  const { labels, data } = combineChartData(chartData);

  return { labels, data: labels.map((_, i) => sumBy(data, d => d[i])) };
}